const BLANK_SCHOOL_NAME_ERROR = 'Please enter a school name.';
const BLANK_SCHOOL_CITY_ERROR = 'Please enter a city.';
const BLANK_ATP_CODE_ERROR = 'Please enter an ATP Code.';

function validateRequiredField(value, requiredFieldError) {
  const errors = [];

  if (!value) {
    errors.push(requiredFieldError);
  }

  return errors.length ? errors : null;
}

export function validateSchoolForm(schoolProfile) {
  const nameErrors = validateRequiredField(schoolProfile.name, BLANK_SCHOOL_NAME_ERROR);
  const cityErrors = validateRequiredField(schoolProfile.city, BLANK_SCHOOL_CITY_ERROR);
  const atpCodeErrors = validateRequiredField(schoolProfile.atpCode, BLANK_ATP_CODE_ERROR);

  if (nameErrors || cityErrors) {
    return {
      name: nameErrors,
      city: cityErrors,
      atpCode: atpCodeErrors
    };
  } else {
    return null;
  }
}